export default "__VITE_ASSET__BL7v95VL__"